import SidebarWebComponent from "./SidebarWebComponent";

if (!customElements.get("plugilo-sidebar")) {
  customElements.define("plugilo-sidebar", SidebarWebComponent);
}

const hasExtensionSidebarKey = "plugilo:extension:has_sidebar";

if (
  sessionStorage.getItem(hasExtensionSidebarKey) !== "true" &&
  !document.getElementById("plugilo-widget-sidebar") &&
  !document.getElementById("plugilo-extension-sidebar")
) {
  const plugiloWrapper = document.createElement("div") as HTMLDivElement;
  plugiloWrapper.id = "plugilo-widget-root";
  document.body.appendChild(plugiloWrapper);

  if (!document.querySelector("plugilo-sidebar")) {
    const plugiloSidebar = document.createElement("plugilo-sidebar");
    plugiloSidebar.style.position = "relative";
    plugiloSidebar.style.zIndex = "2147483647";
    plugiloWrapper.appendChild(plugiloSidebar);
  }
}
